/**
 * Export data to CSV file
 * @param {Array} data - Array of objects to export
 * @param {string} filename - Name of the file (without .csv extension)
 * @param {Array} columns - Optional array of column keys to include
 */
export const exportToCSV = (data, filename, columns = null) => {
  if (!data || data.length === 0) {
    alert('No data to export');
    return;
  }

  // Get columns from first object if not provided
  const keys = columns || Object.keys(data[0]);
  
  // Create CSV header
  const csvHeader = keys.join(',') + '\n';
  
  // Create CSV rows
  const csvRows = data.map(row => {
    return keys.map(key => {
      let value = row[key];
      
      // Handle nested objects
      if (typeof value === 'object' && value !== null) {
        value = JSON.stringify(value).replace(/"/g, '""');
      }
      
      // Handle null/undefined
      if (value === null || value === undefined) {
        value = '';
      }
      
      // Escape commas and quotes
      value = String(value).replace(/"/g, '""');
      
      // Wrap in quotes if contains comma, newline or quote
      if (String(value).includes(',') || String(value).includes('\n') || String(value).includes('"')) {
        value = `"${value}"`;
      }
      
      return value;
    }).join(',');
  }).join('\n');
  
  // Combine header and rows
  const csvContent = csvHeader + csvRows;
  
  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}.csv`);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

/**
 * Flatten nested objects for CSV export
 * @param {Object} obj - Object to flatten
 * @param {string} prefix - Prefix for nested keys
 */
export const flattenObject = (obj, prefix = '') => {
  return Object.keys(obj).reduce((acc, key) => {
    const pre = prefix.length ? prefix + '_' : '';
    
    if (typeof obj[key] === 'object' && obj[key] !== null && !Array.isArray(obj[key])) {
      Object.assign(acc, flattenObject(obj[key], pre + key));
    } else if (Array.isArray(obj[key])) {
      acc[pre + key] = obj[key].join('; ');
    } else {
      acc[pre + key] = obj[key];
    }
    
    return acc;
  }, {});
};
